module.exports = __webpack_public_path__ + "img/30.9d35eac9.jpg";